import { createRequest, platform } from "@shared/platform-api/requests"
import { createRequestHook } from "../createRequestHook"
import { PolicyDocumentsInput, PolicyDocumentsResponse } from "./types"

export const findPolicyDocuments = createRequest<PolicyDocumentsInput, PolicyDocumentsResponse>(
  async (input, getToken) => {
    const documents = await platform(getToken).policies.listPolicyDocuments(input)

    return documents
  }
)

export const usePolicyDocuments = createRequestHook(findPolicyDocuments)
